/**
 * Usage level by fill — shared by every "X of Y" tile (Subscription usage tiles, Agency Hub tiles):
 * < 70% green (success), 70–99% orange (warning), >= 100% red (danger). Used as a suffix for
 * `progress-bar--{level}` and the tiles' own `--{level}` modifiers.
 */
export type UsageLevel = 'success' | 'warning' | 'danger';

export const usageLevel = (used: number, max: number): UsageLevel => {
  const percent = max > 0 ? (used / max) * 100 : 0;
  if (percent >= 100) {
    return 'danger';
  }
  if (percent >= 70) {
    return 'warning';
  }
  return 'success';
};

/** Limit reached (100%+) — the "X of Y" text goes red and a "limit reached" message replaces the %. */
export const isLimitReached = (used: number, max: number): boolean => max > 0 && used >= max;
